import React from 'react';
import PropTypes from 'prop-types';
import './AccordionListItem.scss';

// TODO : currency is now the only piece of hardcoding to solve

const AccordionListItem = (props) => {
  const {
    title,
    description,
    dataSelector,
    dataValue,
    variant,
  } = props;
  return (
    <div
      className="accordion-list-item"
      data-selector={dataSelector}
      data-value={dataValue}
    >
      <div className={`accordion-list-item-title ${variant === 'secondary' ? 'flex-40 font-semibold line-height' : ''}`}>
        {title}
      </div>
      <div className={`accordion-list-item-description ${variant === 'secondary' ? 'flex-60 text-left font-normal line-height' : ''}`}>
        {description}
      </div>
    </div>
  );
};

AccordionListItem.defaultProps = {
  dataSelector: null,
  dataValue: null,
  title: null,
  description: null,
  variant: 'primary',
};

AccordionListItem.propTypes = {
  dataSelector: PropTypes.string,
  dataValue: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  variant: PropTypes.string,
};

export default AccordionListItem;
